<div
  *ngIf="settings"
  class="form-group align-self-end {{
    control && !!control.invalid ? 'fg-invalid' : 'fg-valid'
  }} {{ required ? 'fg-required' : '' }} {{ settings.class }}"
>
  <label for="input-{{ settings.fieldName | titlecase }}">
    {{ settings.label }}
    <span
      *ngIf="required && !disabled && !settings.disableAsterisk"
      class="text-danger required-asterisk-sign"
      >*</span
    >
  </label>
  <div class="" dropdown [insideClick]="true" placement="bottom left">
    <div
      [ngClass]="{
        'd-flex input-group': true
      }"
      [class]="settings.customInputClass"
    >
      <input
        #dropdownInput
        id="input{{ settings.fieldName | titlecase }}"
        name="input{{ settings.fieldName | titlecase }}"
        class="form-control {{
          control && !!control.invalid ? 'ng-invalid' : 'ng-valid'
        }} {{ required ? 'required' : '' }}
        {{ disabled ? 'input-only' : '' }}
        {{
          control?.model?.value && settings?.showFieldHasValue === true
            ? 'filled-out'
            : ''
        }}"
        autocomplete="off"
        [(ngModel)]="data && data.value"
        (ngModelChange)="onChange()"
        [typeahead]="options"
        typeaheadOptionField="value"
        [typeaheadOptionsLimit]="
          options !== null && options.length ? options.length : 55
        "
        [typeaheadItemTemplate]="optionsTemplate"
        [typeaheadOrderBy]="sortConfig"
        [typeaheadScrollable]="true"
        [typeaheadOptionsInScrollableView]="8"
        [typeaheadMinLength]="0"
        [placeholder]="
          selectedOption && selectedOption.value
            ? selectedOption.value
            : settings.placeholder
            ? settings.placeholder
            : ''
        "
        [required]="required"
        [disabled]="disabled"
        (typeaheadOnSelect)="changeSelectedFilter($event)"
        (click)="clickedSelectedFilter()"
        (typeaheadOnBlur)="typeaheadOnBlur($event)"
        (typeaheadNoResults)="changeOnNoResults($event)"
      />
      <rr-info-icon
        *ngIf="settings.showInfoIcon"
        [className]="iconClassName"
        [tooltipText]="settings.infoIconTooltip"
      ></rr-info-icon>
      <div class="input-group-append">
        <button
          *ngIf="!disabled"
          type="button"
          [ngClass]="{
            'dropdown-button activate input-group-text': true,
            'show-arrow-at-end': settings.hideResetInput
          }"
          (click)="clickedDropdown()"
        ></button>
        <button
          type="button"
          *ngIf="!settings.hideResetInput && !disabled"
          class="input-group-text"
          tabindex="-1"
          [disabled]="disabled"
          (click)="onClearInput()"
        >
          <span class="oi oi-x"></span>
        </button>
      </div>
    </div>
    <div class="error-message" *ngIf="showError">
      {{ errors[0] }}
    </div>
  </div>
</div>
